<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <el-form-item v-if="user && ![2, 3, 4, 5].includes(user.user_group_id)" class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
      <template #end>
        <el-form-item class="endBtn">
          <!-- 导出按钮 -->
          <el-button type="primary" icon="el-icon-download" @click="Export(`维保列表_第${page}页`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template #isstatus="params">
        <span class="status status1" v-if="params.params.is_status == 1">车队长审核</span>
        <span class="status status2" v-if="params.params.is_status == 2">机务审核</span>
        <span class="status status3" v-if="params.params.is_status == 3">退回维修商修改</span>
        <span class="status status4" v-if="params.params.is_status == 4">审核通过</span>
      </template>
      <template #status="params">
        <span v-if="params.params.is_settlement == 1">已结算</span>
        <span v-if="params.params.is_settlement != 1" style="color:red;">未结算</span>
      </template>
      <template #btns="params">
        <!-- 查看按钮 -->
        <Btn v-if="!showEdit(params.params)" :config="btns[0]" :data="params.params" />
        <!-- 编辑按钮，未结算才显示 -->
        <Btn v-if="showEdit(params.params)" :config="btns[1]" :data="params.params" />
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "FixList",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'repair',
      breadcrumb: [
        { name: "维保管理", path: `/fix/list` },
        { name: "维保列表", path: `/fix/list` },
      ],
      formCtrl: [
        {
          ...this.ctrls.license,
        },
        {
          label: "维保类型",
          keyName: "articleid",
          placeholder: "请选择维保类型",
          type: "select",
          options: [],
        },
        {
          label: "结算状态",
          keyName: "is_settlement",
          placeholder: "请选择结算状态",
          type: "select",
          options: [
            { label: '全部', value: null },
            { label: '未结算', value: '0' },
            { label: '已结算', value: '1' },
          ],
        },
        {
          label: "维保时间",
          keyName: "rstarttime",
          placeholder: "请选择",
          type: "daterange",
          options: [],
        },
      ],
      cols: [
        { keyName: "license", label: "车牌号", minwidth: 90 },
        { keyName: "driver", label: "司机" },
        { keyName: "article_name", label: "维保类型" },
        { keyName: "rstarttime", label: "维保时间", minwidth: 100 },
        { keyName: "money", label: "维保金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "is_status", label: "审核状态", slot: 'isstatus', minwidth: 100 },
        { keyName: "is_settlement", label: "结算状态", slot: 'status' },
        { keyName: "", label: "操作", slot: 'btns' },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/fix/repairdetail?mode=view&id=${id}`
            );
          },
        },
        {
          ...this.editBtn,
          cb: ({ id, is_status, add_group_id }) => {
          const { user_group_id } = this.user
            let path = '/fix/repairdetail'
            if (
              // 队长
              (user_group_id == 5 && add_group_id == 9 && is_status == 1)
              // 机务
              || (user_group_id == 6 && add_group_id != 6 && is_status == 2)
              // 超管
              // || (user_group_id == 1 && is_status == 4)
            ) {
              path = '/fix/repairexamine'
            }
            this.$router.push({
              path,
              query: {
                mode: 'edit',
                id,
              }
            });
          },
        },
      ],
      getTotalProperty: ['money'],
    };
  },
  methods: {
    showEdit({ is_settlement, is_status }) {
      let boo = false
      const { user_group_id } = this.user
      if (
        // 管理员修改审核通过的单子
        user_group_id === 1 && is_settlement == 1 && is_status == 4 ||
        // 机务审核
        user_group_id === 6 && is_settlement != 1 && is_status == 2 ||
        // 退回维修商修改
        user_group_id === 13 && is_settlement != 1 && is_status == 3
      ) {
        boo = true
      }
      return boo
    },
    onSearchItemChange({ key }) {
      if (['fleet', 'rstarttime', 'articleid', 'is_settlement'].includes(key)) {
        this.getList()
      }
    },
    addItem() {
      this.$router.push(`/fix/repairlistadd`);
    },
    getOptions() {
      let url = `${this.baseUrl}/getsearch`;
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, ({ fleet, article }) => {
        this.formCtrl.map(v => {
          if (v.keyName === 'fleet') {
            v.options = fleet.map(c => {
              return {
                label: c.nickname,
                value: c.id,
              }
            })
          } else if (v.keyName === 'articleid') {
            v.options = article.map(c => {
              return {
                label: c.name,
                value: c.id,
              }
            })
          }
        })
        this.$forceUpdate()
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
  },
  created() {
    if (this.$route.path.includes('orderlist')) {
      this.breadcrumb = [
        { name: "维保管理", path: `/fix/repairer` },
        { name: "维修商管理", path: `/fix/repairer` },
        { name: "维修商订单列表" },
      ]
      this.baseParams.push('r_id')
    }
  },
  mounted() {
    this.getOptions();
    const { user_group_id, id } = this.user
    if ([2, 3, 4].includes(user_group_id)) {
      this.btns.length = 1
    } else if (user_group_id == 5) {
      this.btns.length = 1
      this.formInline.fleet = id
    } else if (user_group_id == 13) {
      this.breadcrumb = [
        { name: '维保管理' }
      ]
    }

    if (Object.keys(this.$route.query).length) {
      this.setQueryParams()
      this.$nextTick(this.getList)
    }
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-form--inline .el-form-item:nth-child(6) .el-range-editor.el-input__inner {
  width: 225px;
}

/deep/ .el-table {

  .status {
    color: #ffe100;

    &.status4 {
      color: #98e098;
    }

    &.status3 {
      color: #fd5b5b;
    }
  }
}
</style>
